import { PdfAction } from '@app/libs/reactPdfJs/store/actions';
import {
  DOCUMENT_SETUP__REQUESTER_FIELD_INSERTING_CANCEL,
  DOCUMENT_SETUP_CLEAR_ALL_STATE,
  DOCUMENT_SETUP_REQUESTER_TEXT_FIELD_INSERTED,
  DOCUMENT_SETUP_REQUESTER_TEXT_FIELD_INSERTING,
  PDF_CLEAR_ALL_STATE,
} from '@app/store/actionTypes';
import { DocumentSetupAction } from '@app/store/documentSetup/actions';

type DocumentSetupIsInsertingRequesterTextFieldState = boolean;

const initialState: DocumentSetupIsInsertingRequesterTextFieldState = false;

export default function reducer(
  state: DocumentSetupIsInsertingRequesterTextFieldState = initialState,
  action: DocumentSetupAction | PdfAction
) {
  switch (action.type) {
    case DOCUMENT_SETUP__REQUESTER_FIELD_INSERTING_CANCEL:
    case DOCUMENT_SETUP_CLEAR_ALL_STATE:
    case DOCUMENT_SETUP_REQUESTER_TEXT_FIELD_INSERTED:
    case PDF_CLEAR_ALL_STATE:
      return false;
    case DOCUMENT_SETUP_REQUESTER_TEXT_FIELD_INSERTING:
      return true;
    default:
      return state;
  }
}
